const messages = {
  title: "Apie BS Plus",
  description: "About page description",
};

export default {
  messages,
};
